module.exports = __webpack_public_path__ + "img/china-southern.0cbc14d2.jpg";